import Skeleton from 'react-loading-skeleton';

import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

type TShowcaseSkeletonProps = {
    count: number,
}

const ShowcaseSkeleton = ({ count }: TShowcaseSkeletonProps) => {
    return (
        <>
            {Array.from({ length: 4 }, (_, key) => (
                <ListContainer
                    key={`Showcase__Category__${key}`}
                    $direction={'column'}
                    $size={24}
                >
                    <Skeleton
                        width={180}
                        height={36}
                        borderRadius={BorderRadius.OuterBlockRadius}
                    />
                    <ListContainer
                        $direction={'row'}
                        $desktop={32}
                        $mobile={24}
                    >
                        {Array.from({ length: count }, (__, cardKey) => (
                            <Skeleton
                                key={`Showcase__Card__${cardKey}`}
                                width={352}
                                height={352}
                                borderRadius={BorderRadius.OuterBlockRadius}
                            />
                        ))}
                    </ListContainer>
                </ListContainer>
            ))}
        </>
    );
};

export default ShowcaseSkeleton;
